import { Grid, styled } from '@mui/material';

const PREFIX = 'HideInfoTooltip';

export const classes = {
  container: `${PREFIX}-container`,
  tooltip: `${PREFIX}-tooltip`,
};

export const StyledGrid = styled(Grid)(({ theme }) => ({
  [`&.${classes.container}`]: {
    left: '-1.5px',
    position: 'absolute',
    top: '-13px',
    transform: 'translateX(-50%)',
    transition: 'opacity 1s ease-out',
    zIndex: 110,
    opacity: 1,
    '&.hide-container': {
      opacity: 0,
    },
  },

  [`& .${classes.tooltip}`]: {
    backgroundColor: theme.palette.primary.main,
    border: `1px solid ${theme.palette.primary.main}`,
    borderRadius: 4,
    color: theme.palette.common?.white,
    display: 'inline-block',
    fontSize: theme.spacing(2),
    fontWeight: theme.typography.body1?.fontWeight,
    padding: theme.spacing(1),
    position: 'relative',
    textAlign: 'center',
    // Arrow
    '&::before': {
      borderColor: `${theme.palette.primary.main} transparent transparent transparent`,
      borderStyle: 'solid',
      borderWidth: '5px',
      content: '""',
      left: '50%',
      marginLeft: '-5px',
      position: 'absolute',
      top: '100%',
    },
  },
}));